import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../contexts/ProfileContext';

interface Props {
  children: ReactNode;
}

/**
 * Gate de onboarding (Fase 5).
 *
 * Se `useProfile().needsOnboarding === true`, redireciona para `/onboarding`
 * preservando a rota original em `state.from`. Caso contrário, renderiza
 * children normalmente.
 *
 * IMPORTANTE: este wrapper roda DEPOIS do `AuthGuard` — assume usuário
 * autenticado. A rota `/onboarding` NÃO deve usar este wrapper, para evitar
 * loop infinito (usar apenas `<AuthGuard>`).
 */
export default function RequireOnboarding({ children }: Props) {
  const { loading, needsOnboarding } = useProfile();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (needsOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
